import React from 'react'
import PropTypes from 'prop-types'
import RoundIcon from '../../../../shared/settings/round-icon'
import editIcon from '../../../../../../images/pencil.svg'

import styles from '../payment.css'

const EditIcon = ({ onClick }) => {
  return (
    <div
      className={styles.editButton}
      onClick={onClick}
    >
      <RoundIcon alt="Edit Icon" src={editIcon} />
    </div>
  )
}

EditIcon.propTypes = {
  onClick: PropTypes.func
}

EditIcon.defaultProps = {
  onClick: () => {}
}

export default EditIcon
